export enum EqualizationFactorIntent {
    None = 0,
    Set = 1,
    OptOut = 2,
    Revert = 3,
}

export class Assessment {
    constructor(annualYearID: number, revisionNumber: number, status: number, efAction: string, annualAssessmentDetails: AnnualAssessmentDetail[]) {
        this.annualYearID = annualYearID;
        this.revisionNum = revisionNumber;
        this.status = status;
        this.annualAssessmentDetails = annualAssessmentDetails;
        this.efAction = efAction;
        this.revisionDesc = '';
    }

    allocationId: number;
    annualAssessmentDetails: AnnualAssessmentDetail[];
    annualAssessmentID: number;
    annualYearID: number;
    annualYear: any;
    revisionNum: number;
    status: number;
    finalRevision: boolean;
    revisionDate: Date;
    revisionDesc: string;
    hasAttachments: boolean;
    appealDeadLineID: number;
    appealDeadline: Date;
    originalDeadline: Date;
    hasComments: boolean;
    efAction: string;
    rowVersion: any;
    annualYearRowVersion: any;
    equalizationFactorIntent: EqualizationFactorIntent;
    equalizationFactor: number;
    hasInProgressIntakeItems: boolean;
    taxableValues: Core.AnnualAssessmentTaxableValue[];
    // Set to true only when the user actually stages an add/remove/rename/reorder/value edit during
    // this edit session; the server uses this (rather than checking whether taxableValues is
    // populated) to distinguish "no taxable-value edit was made" from "delete every row".
    taxableValuesEdited?: boolean;
    // Persisted taxable-value rows the user removed during this edit session. They are kept apart from
    // taxableValues so the rest of the tab only ever sees the remaining rows, and are added back to the
    // save payload flagged as deleted.
    deletedTaxableValues?: TaxableValueInfo[];
    taxAuthoritiesInfo: Core.TaxAuthorityInfo[];
    hasNegativeTaxable: boolean;
    canAddTaxableValue: boolean;
    // Whether the prior Tax Year makes Calc TV Using applicable (independent of this year's Auto Calculate TV checkbox).
    isCalcTvUsingRelevant: boolean;
    // The rows Prior Year Setup would give this year, for previewing; they carry no identity worth saving.
    priorYearTaxableValues: Core.AnnualAssessmentTaxableValue[];
    canRecalculateTaxableValue: boolean;
    capRuleInfo: Core.AnnualAssessmentCapRuleInfo;
    // Sent when saving from a screen that can show the Add Year dialog, so the server returns addYearPrompt instead of
    // silently creating a subsequent Tax Year whose taxable-value setup needs the user's review.
    allowAddYearPrompt?: boolean;
    // Set by the server when saving did not create the subsequent Tax Year and the Add Year dialog must be shown.
    addYearPrompt?: Core.AddYearPromptInfo;
}

export class AnnualAssessmentDetail {
    assessmentClassComponent: any; //I don't know what this is
    assessmentClassRatio: AssessmentClassRatio;
    annualAssessmentDetailID: number;
    annualAssessmentID: number;
    assessmentClassComponentID: number;
    assessmentClassRatioID: number;
    ratio: number;
    displayRatio: number;
    assessedValue: number;
    fairMarketValue: number;
    fmvOverridden: boolean;
    componentName: string;
    assessmentComponentTypeID: number;
    efAction: string;
    sequence: number;
    isFromIdp?: { [value: string]: boolean };
}

export class AssessmentClassRatio {
    assessmentClassRatioID: number;
    assessmentClassID: number;
    assessorID: number;
    taxYear: number;
    assessmentRatio: number;
    efAction: string;
}

export class TaxableValueInfo implements Core.AnnualAssessmentTaxableValue {
    annualAssessmentTaxableValueId: number;
    assessedValue: number;
    marketValue: number;
    sequence: number;
    description: string;
    taxAuthorityIds: number[] = [];
    taxAuthorityId?: number;
    taxAuthorityName: string;
    taxAuthorityNames: string[] = [];
    taxAuthorityCategory: string;
    taxAuthorityCategories: string[] = [];
    taxAmount: number;
    taxableAssessmentName: string;
    taxableAssessmentNames: string[] = [];
    adjustmentAssessedValue: number;
    hadNegativeAssessedValue?: boolean;
    hadNegativeMarketValue?: boolean;
    hasConfigurationChanged: boolean;
    // Manual Taxable Value mode staging: true for a row added client-side that has not yet been saved.
    isNew?: boolean;
    // Sent to the server for a persisted row the user removed; sequence then holds the row's position at removal.
    isDeleted?: boolean;
}
